// eventBus.js
module.exports = (function () {

    const eventBus = new Vue();
	return eventBus;
}());